// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '0 30px',
    backgroundColor: GlobalStyles.color.COLOR_GREEN,

    [theme.breakpoints.down(450)]: {
      flexDirection: 'column',
      // Was '10px 100px 10px 10px'. That 100px on the right pushed everything
      // left and made "centred" impossible - the button sat at the middle of
      // a box whose right third was padding. Same as the issue-voucher band.
      padding: 10,
      alignItems: 'flex-start',
    },
  },
  textContainer: {
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_PRIMARY,
  },
  textTop: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  textBottom: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
  },
  buttonStyle: {
    // Centred once the band stacks; on a wide screen it stays to the right of
    // the text, as before.
    [theme.breakpoints.down(450)]: {
      alignSelf: 'center',
      marginTop: 8,
    },
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
    borderColor: GlobalStyles.color.COLOR_PRIMARY,
    background: 'none',
    borderWidth: 1,
    borderStyle: 'solid',
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    padding: '5px 10px',
    transition: 'all .1s ease-in-out',
    '&:hover': {
      backgroundColor: 'rgb(90, 200, 150) !important',
      transform: 'scale(1.05)',
    }
  },
});

export default styles;
